import useStyles from './Content.styled'

export const useContent = props => {
	const { text, textConfig, extraShortcuts, onTextClick, classes, textEditable, onTextChange, textKey } = props

	const contentClasses = useStyles(props)

	return [
		{
			classes: { ...classes, ...contentClasses },
			extraShortcuts,

			text,
			textKey,
			textConfig,
			textEditable,
		},
		{
			handleTextClick: onTextClick,
			handleTextChange: onTextChange,
		},
	]
}
